import { createRouter, createWebHistory } from "vue-router";
import { useStore } from "vuex";
import sessionTimeout from "../utils/session-timeout";
import Balance from "../views/Balance/Balance.vue";
import Signup from "../views/auth/Signup.vue";
import SetPassword from "../views/auth/SetPassword.vue";
import Signin from "../views/auth/Signin.vue";
import Otp from "../views/auth/Otp.vue";
import VerifyEmail from "../views/auth/VerifyEmail.vue";
import VerifyCompleted from "../views/auth/VerifyCompleted.vue";
import DashboardApp from "../views/dashboard/Dashboard.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import ForgotPasswordNotify from "../views/auth/ForgotPasswordNotify.vue";
import ResetPassword from "../views/auth/ResetPassword.vue";
import ResetPasswordNotify from "../views/auth/ResetPasswordNotify.vue";
import DetailCompany from "../views/company/DetailCompany.vue";
import Transaction from "../views/Transaction/Transaction.vue";
import TransactionDetail from "../views/Transaction/TransactionDetail.vue";
import DocumentCompany from "../views/company/DocumentCompany.vue";
import BankCompany from "../views/company/BankCompany.vue";
import HelpCenter from "../views/help/HelpCenter.vue";
import Transfer from "../views/Transfer/Transfer.vue";
import Profile from "../views/profile/Profile.vue";
import OtpVerification from "../views/auth/OtpVerification.vue";
import VirtualAccountDisplay from "../views/Transfer/components/VirtualAccountDisplay.vue";
import PaymentSuccess from "../views/Transfer/components/PaymentSuccess.vue"; // Import the new component
import PaymentCancelled from "../views/Transfer/components/PaymentCancelled.vue"; // Tambahkan import komponen baru
import Integrations from "../views/Integrations/Integrations.vue";
import UserManagement from "../views/UserManagement/UserManagement.vue";
import UserManagementDetail from "../views/UserManagement/UserManagementDetail.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    redirect: "/home",
  },
  {
    path: "/home",
    name: "DashboardApp",
    component: DashboardApp,
  },
  {
    path: "/company-detail",
    name: "DetailCompany",
    component: DetailCompany,
  },
  {
    path: "/company-document",
    name: "DocumentCompany",
    component: DocumentCompany,
  },
  {
    path: "/company-bank",
    name: "BankCompany",
    component: BankCompany,
  },
  {
    path: "/balance",
    name: "Balance",
    component: Balance,
  },
  {
    path: "/transaction",
    name: "Transaction",
    component: Transaction,
  },
  {
    path: "/transaction/:id",
    name: "TransactionDetail",
    component: TransactionDetail,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/verify-completed",
    name: "VerifyCompleted",
    component: VerifyCompleted,
    // beforeEnter: (to, from, next) => {
    //   const store = useStore();
    //   if (!store.state.auth.email) {
    //     next({ name: "Signup" });
    //   } else {
    //     next();
    //   }
    // },
  },
  {
    path: "/email-verify",
    name: "VerifyEmail",
    component: VerifyEmail,
    beforeEnter: (to, from, next) => {
      const store = useStore();
      if (!store.state.auth.email) {
        next({ name: "Signup" });
      } else {
        next();
      }
    },
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/verify-otp",
    name: "VerifyOtp",
    component: Otp,
    beforeEnter: (to, from, next) => {
      const store = useStore();
      if (!store.state.auth.email) {
        next({ name: "Signin" });
      } else {
        next();
      }
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
  },
  {
    path: "/forgot-password-notify",
    name: "ForgotPasswordNotify",
    component: ForgotPasswordNotify,
    beforeEnter: (to, from, next) => {
      const store = useStore();
      if (!store.state.auth.email) {
        next({ name: "ForgotPasswordNotify" });
      } else {
        next();
      }
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/reset-password/:resetPasswordToken",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/reset-password-notify",
    name: "ResetPasswordNotify",
    component: ResetPasswordNotify,
  },
  {
    path: "/help-center",
    name: "HelpCenter",
    component: HelpCenter,
  },
  {
    path: "/transfer",
    name: "Transfer",
    component: Transfer,
  },
  {
    path: "/verify-otp-verification",
    name: "OtpVerification",
    component: OtpVerification,
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-instructions", // Or a more descriptive path like /transfer/:batchId/va-payment
    name: "VirtualAccountDisplay",
    component: VirtualAccountDisplay,
    meta: { requiresAuth: true },
  },
  {
    path: "/payment-success", // Define the path for the success page
    name: "PaymentSuccess", // Define the route name
    component: PaymentSuccess,
    meta: { requiresAuth: true }, // Assuming this page also requires authentication
  },
  {
    path: "/payment-cancelled", // Path untuk halaman cancelled
    name: "PaymentCancelled", // Nama route
    component: PaymentCancelled,
    meta: { requiresAuth: true },
  },
  {
    path: "/integrations",
    name: "Integrations",
    component: Integrations,
    meta: { requiresAuth: true },
  },
  {
    path: "/user-management",
    name: "UserManagement",
    component: UserManagement,
    meta: { requiresAuth: true },
  },
  {
    path: "/user-management/:id",
    name: "UserManagementDetail",
    component: UserManagementDetail,
    meta: { requiresAuth: true },
  },
  {
    path: "/set-password",
    name: "SetPassword",
    component: SetPassword,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

const publicPages = [
  "Signin",
  "SetPassword",
  "Signup",
  "VerifyOtp",
  "VerifyEmail",
  "VerifyCompleted",
  "ForgotPassword",
  "ForgotPasswordNotify",
  "ResetPassword",
  "ResetPasswordNotify",
  "Profile",
];
router.beforeEach((to, from, next) => {
  const store = useStore();
  const token = store.state.auth.token || localStorage.getItem("auth_token");

  if (!token && !publicPages.includes(to.name)) {
    next({ name: "Signin" });
  } else {
    if (token && !store.state.auth.token) {
      store.commit("auth/setToken", token);
    }

    // Reset session timeout on navigation if user is authenticated
    if (token && !publicPages.includes(to.name)) {
      sessionTimeout.resetTimer();
    }

    next();
  }
});

export default router;
